import* as React from "react";

import Header from "../../components/common/Header.jsx";
import Footer from "../../components/common/Footer.jsx";
import NotificationsPopup from "../common/NotificationsPopup";

import SiteSetupContainer from "./SiteSetupContainer.jsx";

const SiteSetupPage = () => (
    <div className="container">
        <div id="SiteSetupPage">
            <NotificationsPopup/>

            <Header hideLogout={true}/>

            <SiteSetupContainer />
            <Footer/>
        </div>
    </div>
);

export default SiteSetupPage;
